import { useAppSelector } from "@/store";
import { UserAreaName } from "@/types/user.types";

export const useUserAreas = (): UserAreaName[] => {
    const userAreas = useAppSelector((state) => state.user.areas);
    return userAreas;
};
